module.exports = __webpack_public_path__ + "img/weigth.5424e3a6.png";